module.exports = __webpack_public_path__ + "img/icon.c48d046f.png";